import React, {useEffect, createRef} from 'react'

export default Wrapped => {

    const handleClick = event => {
        const {
            currentTarget
        } = event


        const type = currentTarget.getAttribute("data-type")
        const id = currentTarget.getAttribute("data-id")
        const position = currentTarget.getAttribute("data-position")
        const tab = currentTarget.getAttribute("data-tab")
       
        window.GeekoSensors.Track("ClogClick", {
            type,
            clog_id:id,
            position,
            tab
        })

    }


    return props => {
        const { removeClick } = props;
        const dom = createRef()
        useEffect(() => {
            window?.clogSourceObserver?.observe(dom.current)

            !removeClick && dom?.current?.addEventListener?.('click', handleClick)

            return () => {
                window?.clogSourceObserver?.unobserve(dom.current)
            }
        }, [])
        return <Wrapped innerRef={dom} {...props}/>
    }
}